import repeat from "@lib/util/repeat"
import SkeletonProductPreview from "@modules/skeletons/components/skeleton-product-preview"
import React, { useEffect, useState } from "react"
import {
    FullTextProp,
    HeroProp,
    OneImageProp,
    TwoImageProp,
} from "@lib/data/_types"
import { useInView } from "react-intersection-observer"
import { collectionType } from "@lib/data/collections"
import RenderItem from "@modules/common/render-item"

const SkeletonCollectionPage = ({
    content,
}: {
    content?: collectionType | null
}) => {
    const items = content?.content
    /*const [firstItem, setFirstItem] = useState<
        HeroProp | OneImageProp | TwoImageProp | FullTextProp
    >()
    const [items, setItems] =
        useState<Array<HeroProp | OneImageProp | TwoImageProp | FullTextProp>>()*/

    /*useEffect(() => {
        const items = content?.content
        setFirstItem(items?.shift())
        setItems(items)
    }, [content])*/
    return (
        <div className={"grain-background"}>
            <div
                className={
                    "relative z-10 grid grid-cols-1 small:grid-cols-6  px-4 py-7 lg:px-12 lg:py-20"
                }
            >
                {items && <RenderItem item={items[0]} />}

                <div className="relative block col-span-4 small:col-span-1 h-20 bg-gray-100"></div>
                <div className="col-span-5 small:px-8 transition flex flex-col small:items-start py-6">
                    <div className={"small:content-container "}>
                        <ul className="grid grid-cols-2 small:grid-cols-3 medium:grid-cols-4 gap-x-4 gap-y-8">
                            {repeat(8).map((index) => (
                                <li key={index}>
                                    <SkeletonProductPreview />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>

            <div
                className={
                    "relative z-10 grid grid-cols-1 small:grid-cols-6 px-4 small:px-0 py-7"
                }
            >
                {items &&
                    items.map((item, index) =>
                        index === 0 ? <></> : <RenderItem item={item} />
                    )}
            </div>
            <div
                className={"absolute inset-0 z-0 pointer-events-none"}
                style={{
                    background:
                        "linear-gradient(\n" +
                        "    to right,\n" +
                        "    transparent 0%,\n" +
                        "    transparent 33.33%,\n" +
                        "    #f6f6f6 33.33%,\n" +
                        "    #f6f6f6 100%\n" +
                        "  )",
                }}
            >
                &nbsp;
            </div>
        </div>
    )
}

export default SkeletonCollectionPage
